import styled, { css } from "styled-components";

export const ModalHeaderWrapper = styled.div`
  ${({ theme }) => css`
    height: 79px;
    display: flex;
    justify-content: space-between;
    background-color: ${`${theme?.colour?.primary}0D`};
  `}
`;
